import React, {Component} from 'react'
import FriendListEntry from './FriendListEntry'
import { v4 as uuidv4 } from 'uuid'; 
import { screenType } from './myFunctions';
export default function FriendList({list,oym,dropBreadcrumb}) {
    // this.name="Membership List"
    // console.log(oym);
    // console.log("Friends:"+list.length);
    // console.log("FriendListEntry:",list);

    let objectList=list.map(friend => oym.objectRef(friend));
    // console.log("FIL dropBreadcrumb function:",dropBreadcrumb);
    // console.log(objectList);
    objectList.sort(oym.compareFriend);
    // console.log(objectList);
    let meetingHeader = (screenType()!=="Small") ? (<><th>Membership</th><th>Meeting</th></>) : (<></>);
    
    return (
        // each friend at this point simply contains id of the friend, which 
        // must be used to look up the Friend object in FriendListEntry.
        <>
        <table>
        <tr>
            <th>Sorted by</th>
            <th>Name</th>
            {meetingHeader}
        </tr>
        {objectList.map(friend => {
                return <FriendListEntry key={uuidv4()} friend={friend} oym={oym} dropBreadcrumb={dropBreadcrumb}/> 
            })
        }
        </table>
        </> 
    )
}
